class UserRole {
    constructor() {
        this.showUserMenu=false
        this.showAuditMenu=false
        this.updateProductCatlog=false
        this.AddProduct=false
        this.updateProductPrice=false
        this.updateProduct=false
        this.updateProgress=false
        this.manageFile=false
        this.manageMeasure=false
        this.changePrice=false
    }

}

///产品部审核权限
let productDepartmentAuditRole = new UserRole()
productDepartmentAuditRole.showAuditMenu=true


//产品部编辑权限
let productDepartmentEditRole = new UserRole()
productDepartmentEditRole.updateProductCatlog=true
productDepartmentEditRole.AddProduct=true
productDepartmentEditRole.updateProduct=true
productDepartmentEditRole.updateProgress=true
productDepartmentEditRole.manageFile=true
productDepartmentEditRole.manageMeasure=true

///管理员权限
let adminRole = new UserRole()
adminRole.showUserMenu=true
adminRole.showAuditMenu=true
adminRole.updateProductCatlog=true
adminRole.AddProduct=true
adminRole.updateProductPrice=true
adminRole.updateProduct=true
adminRole.updateProgress=true
adminRole.manageFile=true
adminRole.manageMeasure=true

///财务权限
let financialRole = new UserRole()
financialRole.changePrice=true

///ceo权限
let CEORole = new UserRole()
CEORole.showAuditMenu=true

//其他权限
let otherRole=new UserRole()



let roles = [
    {
        name: '管理员', 'role': adminRole
    },
    {
        name: '产品开发部(修改)', 'role': productDepartmentEditRole
    },
    {
        name: '产品开发部(审核)', 'role': productDepartmentAuditRole
    },
    {
        name: '研发中心', 'role': otherRole
    },
    {
        name: '营销中心', 'role': otherRole
    },
    {
        name: '财务', 'role': financialRole
    },
    {
        name: '其他', 'role': otherRole
    },
    {
        name: '总经理', 'role': CEORole
    },

]




let getRole = function () {
    let roleName = sessionStorage.getItem('role')
    let role = roles.find(item => item.name == roleName)
    if (role == undefined)
        return new UserRole()
    else
        return role.role
}

export default getRole